import React, { createContext, PropsWithChildren } from 'react'
import { CombinedError, useMutation } from 'urql'

import {
  CartPageQuery,
  CartPaymentQuery,
  RemoveCartDiscountByCodeDocument,
  RemoveCartServiceChargeDocument,
} from '@/gql/graphql'

import { CartSummary } from './CartSummary'
import { CartStaleWrapper } from './shared'

export interface CheckoutCTAProps {
  cart?: CartPageQuery['getCart'] | CartPaymentQuery['getCart']
  stale?: boolean
  allowSurcountRemoval?: boolean
  allowServiceChargeRemoval?: boolean
}

export const CheckoutContext = createContext<{
  discountLoading: boolean
  serviceChargeLoading: boolean
  loading: boolean
  serviceChargeError?: CombinedError
}>({
  discountLoading: false,
  serviceChargeLoading: false,
  loading: false,
})

export const CheckoutCTA = ({
  cart,
  stale = false,
  allowSurcountRemoval,
  allowServiceChargeRemoval,
  children,
}: PropsWithChildren<CheckoutCTAProps>) => {
  const [{ fetching: discountLoading }, removeDiscount] = useMutation(
    RemoveCartDiscountByCodeDocument,
  )
  const [
    { fetching: serviceChargeLoading, error: serviceChargeError },
    removeServiceCharge,
  ] = useMutation(RemoveCartServiceChargeDocument)

  return (
    <CheckoutContext.Provider
      value={{
        discountLoading,
        serviceChargeLoading,
        serviceChargeError,
        loading: discountLoading || serviceChargeLoading,
      }}
    >
      <div>
        {cart && (
          <div className="mb-3 sm:mb-4">
            <div className="mb-2">
              <CartStaleWrapper loading={stale} spinner={false}>
                <CartSummary
                  removeDiscount={removeDiscount}
                  removeServiceCharge={removeServiceCharge}
                  cart={cart}
                  allowSurcountRemoval={allowSurcountRemoval}
                  allowServiceChargeRemoval={allowServiceChargeRemoval}
                />
              </CartStaleWrapper>
            </div>
          </div>
        )}
        {children}
      </div>
    </CheckoutContext.Provider>
  )
}
